import React, { useState, useEffect } from "react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faAnglesUp } from "@fortawesome/free-solid-svg-icons"
import { animateScroll as scroll } from "react-scroll"
import * as style from "./style.module.css"

const Component = () => {
  const [isVisible, setIsVisible] = useState(false)
  useEffect(() => {
    if (typeof window === "undefined") return // window check.

    const toggleVisibility = () => {
      if (typeof window !== "undefined") {
        if (window.scrollY > 300) {
          setIsVisible(true)
        } else {
          setIsVisible(false)
        }
      }
    }

    if (typeof window !== "undefined") {
      window.addEventListener("scroll", toggleVisibility)
    }

    return () => {
      if (typeof window !== "undefined") {
        window.removeEventListener("scroll", toggleVisibility)
      }
    }
  }, [])

  const scrollToTop = () => {
    scroll.scrollToTop()
  }

  return (
    <>
      <div
        className={`${style.topPageButton} ${isVisible ? style.show : ""}`}
        onClick={scrollToTop}
      >
        <FontAwesomeIcon className={style.hamNav_itemIcon} icon={faAnglesUp} />{" "}
        To page top
      </div>
    </>
  )
}

export default Component
